import React, { useState } from "react";

import { Formik } from "formik";
import { Col, Form, Row, Button, Spinner } from "react-bootstrap";
import { sendNewsLetter } from "../../apis/authApis";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import style from "./newsletter.module.css"

const NewsLetter = () => {
    const dispatch = useDispatch();
    const [disableButton, setDisableButton] = useState(false);

    return (
        <>
            <div>
                <div className={style.newsletterimg}>
                    <div className="container">
                        <div className={style.newslettertext}>
                            <h1>Stay Connected with FundLife</h1>
                            <h3>Be the first to hear stories of impact, new campaigns, and ways to make a difference.</h3>

                                <div className={style.mainform}>
                            <Formik
                                initialValues={{
                                    name: "",
                                    email: "",
                                   
                                }}
                                validationSchema={Yup.object().shape({
                                    name: Yup.string().max(255).required("Name is required"),
                                    email: Yup.string()
                                        .email("Must be a valid email")
                                        .max(255)
                                        .required("Email is required"),
                                })}
                                onSubmit={async (
                                    values,
                                    { setErrors, setStatus, setSubmitting, resetForm }
                                ) => {
                                    try {
                                        setDisableButton(true);
                                        setStatus({ success: false });
                                        setSubmitting(false);
                                        dispatch(sendNewsLetter(values)).then(() => {
                                            setDisableButton(false);
                                            resetForm();
                                        });
                                    } catch (err) {
                                        setStatus({ success: false });
                                        setErrors({ submit: err.message });
                                        setSubmitting(false);
                                        setDisableButton(false);
                                    }
                                }}
                            >
                                {({
                                    errors,
                                    handleBlur,
                                    handleChange,
                                    handleSubmit,
                                    isSubmitting,
                                    touched,
                                    values,
                                }) => (
                                    <Form noValidate onSubmit={handleSubmit}>
                                        <Form.Group className="mb-3 mb-lg-4" controlId="formBasicName">
                                            <Form.Label className="text-white fw-medium" style={{ fontSize: "14px" }}>Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                             className={`${style.customname} ${touched.name && errors.name ? "is-invalid" : ""}`}

                                                value={values.name}
                                                name="name"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                error={Boolean(touched.name && errors.name)}
                                            />
                                            {touched.name && errors.name && (
                                                <Form.Text className=" text-danger">
                                                    {errors.name}
                                                </Form.Text>
                                            )}
                                        </Form.Group>

                                        <Form.Group  controlId="formBasicEmail">
                                            <Form.Label className="text-white fw-medium" style={{ fontSize: "14px" }}>Email </Form.Label>
                                            <Form.Control
                                              className={`${style.customemail} ${touched.name && errors.name ? "is-invalid" : ""}`}

                                                type="email"
                                                value={values.email}
                                                name="email"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                error={Boolean(touched.email && errors.email)}
                                            />
                                            {touched.email && errors.email && (
                                                <Form.Text className=" text-danger">
                                                    {errors.email}
                                                </Form.Text>
                                            )}
                                        </Form.Group>
                                        <Button
                                            className={style.submitbutton}
                                            variant="danger"
                                            type="submit"
                                            disabled={disableButton}
                                        >
                                           Submit
                                            {disableButton && (
                                                <Spinner
                                                    className="ms-3"
                                                    as="span"
                                                    animation="grow"
                                                    size="sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                />
                                            )}
                                        </Button>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                        </div>
                    
                     
                    </div>
                </div>
            </div>
        </>
    );
};

export default NewsLetter;
